export default __webpack_public_path__ + "media/images/avatars/avatar4-996c1977f49a024a8a4d40427aa17aa0.png";